(() => {
  if (window.meriphoraSizeGuideInitialized) {
    return;
  }

  window.meriphoraSizeGuideInitialized = true;

  const syncGuideVisibility = (guide) => {
    const activeCountry = guide.dataset.activeCountry || 'de';
    const activeUnit = guide.dataset.activeUnit || 'cm';

    guide.querySelectorAll('[data-unit-visible], [data-country-visible]').forEach((item) => {
      const itemCountry = item.dataset.countryVisible;
      const itemUnit = item.dataset.unitVisible;
      const countryMismatch = itemCountry && itemCountry !== activeCountry;
      const unitMismatch = itemUnit && itemUnit !== activeUnit;

      item.hidden = Boolean(countryMismatch || unitMismatch);
    });

    guide.querySelectorAll('[data-size-guide-unit-toggle]').forEach((button) => {
      button.setAttribute('aria-pressed', activeUnit === 'in' ? 'true' : 'false');
    });
  };

  const activateGuideTab = (button) => {
    const guide = button.closest('[data-meriphora-size-guide]');
    const target = button.dataset.sizeGuideTab;

    if (!guide || !target) {
      return;
    }

    guide.querySelectorAll('[data-size-guide-tab]').forEach((tab) => {
      const isActive = tab === button;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    guide.querySelectorAll('[data-size-guide-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.sizeGuidePanel !== target;
    });
  };

  const toggleGuideUnit = (button) => {
    const guide = button.closest('[data-meriphora-size-guide]');

    if (!guide) {
      return;
    }

    guide.dataset.activeUnit = guide.dataset.activeUnit === 'in' ? 'cm' : 'in';
    syncGuideVisibility(guide);
  };

  const activateGuideCountry = (select) => {
    const guide = select.closest('[data-meriphora-size-guide]');

    if (!guide) {
      return;
    }

    guide.dataset.activeCountry = select.value || 'de';
    syncGuideVisibility(guide);
  };

  document.querySelectorAll('[data-meriphora-size-guide]').forEach(syncGuideVisibility);

  document.addEventListener('click', (event) => {
    const tab = event.target.closest('[data-size-guide-tab]');

    if (tab) {
      activateGuideTab(tab);
      return;
    }

    const unit = event.target.closest('[data-size-guide-unit-toggle]');

    if (unit) {
      toggleGuideUnit(unit);
    }
  });

  document.addEventListener('change', (event) => {
    const country = event.target.closest('[data-size-guide-country]');

    if (country) {
      activateGuideCountry(country);
    }
  });
})();
